import { Box, CheckBox, ModBox, Text } from '@jfs/ui-new'
import debounce from 'lodash/debounce'
import { useEffect, useState } from 'react'
import { TOneSearchBar } from '../../../components/TOneSearchBar'
import { useStores } from '../../../data/store'
import { PAYMENT_MODE_SUBTYPES } from '../../../utils/constants'
import { NBContainer } from '../NetBanking/NBContainer'

interface NetBankingProps {
  type: string
  isEdit?: boolean
}
const CorporateNetBanking = ({ type, isEdit }: NetBankingProps) => {
  const { updateAllSelection, setSearchString, searchString, bankListLength, isAllBankSelected } = useStores(
    (root) => ({
      updateAllSelection: root.updateAllSelection,
      setSearchString: root.setSearchString,
      searchString: root.onboarding.searchString,
      bankListLength: root.onboarding.merchant.preferences.corpBankList.length,
      isAllBankSelected: root.onboarding.isAllBanksSelected,
      bankSelectedLength: root.corporateBanksSelectedLength(),
    }),
  )
  const [showAllBanks, setShowAllBanks] = useState(isAllBankSelected)

  useEffect(() => {
    setShowAllBanks(isAllBankSelected)
  }, [isAllBankSelected])

  const onChange = (isChecked: string) => {
    setShowAllBanks(isChecked === 'true')
    updateAllSelection(isChecked === 'true', PAYMENT_MODE_SUBTYPES.CORP_NB)
  }

  const onSearchChange = debounce((searchString: string) => {
    setSearchString(searchString)
  }, 30)

  const setIsAllChecked = (isChecked: boolean) => {
    setShowAllBanks(isChecked)
  }

  return (
    <Box f={1} overflow={'auto'} ph={40} pv={40} minHeight={600}>
      <Text title={'Select banks to provide access'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
      <ModBox
        w={'100%'}
        flexDirection={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
        marginVertical={24}
        height={32}>
        <ModBox>
          <CheckBox
            textStyle={'body'}
            onChange={onChange}
            textLabel={'Select all banks'}
            checked={showAllBanks}
            iconSize={16}
            disabled={!isEdit}
            color={isEdit ? 'BLUE_SHADE_PRIMARY' : 'DARK_GREY'}
            fontSize={12}
          />
        </ModBox>
        <Box width={220} h={32}>
          <TOneSearchBar
            hide={false}
            placeholder={'Search Banks'}
            value={searchString}
            autoFocus={false}
            isSearch={true}
            onChange={onSearchChange}
          />
        </Box>
      </ModBox>
      <NBContainer
        bankType={PAYMENT_MODE_SUBTYPES.CORP_NB}
        isAllChecked={showAllBanks}
        isEdit={isEdit}
        setIsAllChecked={setIsAllChecked}
      />
    </Box>
  )
}

export { CorporateNetBanking }
